(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
/* Standalone Shopify section enhancement. Native links and forms stay native. */
(() => {
  if (!window.customElements || customElements.get('flexora-footer')) return;

  class FlexoraFooter extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const { signal } = this._controller;
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), { once: true, signal });
      } else {
        this.initialize();
      }
    }

    initialize() {
      if (!this.isConnected || this._initialized) return;
      this._initialized = true;
      const { signal } = this._controller;
      this._motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._desktop = window.matchMedia('(min-width: 750px)');
      this._accordions = Array.from(this.querySelectorAll('[data-accordion]')).map((details) => ({
        details,
        summary: details.querySelector(':scope > summary'),
        panel: details.querySelector(':scope > .flexora-footer__accordion-panel'),
        mobileOpen: false,
        targetOpen: true,
        animation: null,
      })).filter((state) => state.summary && state.panel);

      this._accordions.forEach((state) => {
        state.originalTabindex = state.summary.getAttribute('tabindex');
        state.originalDisabled = state.summary.getAttribute('aria-disabled');
        // Preserve access if focus was already inside the section before enhancement.
        state.mobileOpen = state.panel.contains(document.activeElement);
        state.summary.addEventListener('click', (event) => {
          event.preventDefault();
          if (!this.accordionMode) return;
          state.mobileOpen = !state.targetOpen;
          this.setAccordion(state, state.mobileOpen, true);
        }, { signal });
        state.details.addEventListener('toggle', () => {
          if (state.animation) return;
          if (!this.accordionMode && !state.details.open) {
            this.setAccordion(state, true, false);
          } else if (this.accordionMode && state.details.open !== state.targetOpen) {
            // Also respect a browser opening details for find-in-page or a fragment.
            state.mobileOpen = state.details.open;
            state.targetOpen = state.details.open;
          }
        }, { signal });
      });

      this._desktop.addEventListener('change', () => this.syncAccordions(), { signal });
      this._motion.addEventListener('change', () => {
        this.syncAccordions();
        if (this._motion.matches) this.revealAll();
        else this.setupReveals();
      }, { signal });
      window.addEventListener('resize', () => {
        if (this._resizeFrame) return;
        this._resizeFrame = requestAnimationFrame(() => {
          this._resizeFrame = null;
          // Settle an in-flight height transition before its measurements go stale.
          this._accordions.forEach((state) => {
            if (state.animation) this.setAccordion(state, state.targetOpen, false);
          });
        });
      }, { passive: true, signal });

      this.addEventListener('focusin', (event) => {
        this.querySelectorAll('.is-reveal-pending').forEach((element) => {
          if (element.contains(event.target)) this.reveal(element);
        });
      }, { signal });
      const showSelection = (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;
        if (!this.contains(target) && !target.contains(this)) return;
        this.revealAll();
        this._accordions.forEach((state) => {
          if (state.details.contains(target) || target.contains(state.details)) {
            state.mobileOpen = true;
            this.setAccordion(state, true, false);
          }
        });
      };
      document.addEventListener('shopify:section:select', showSelection, { signal });
      document.addEventListener('shopify:block:select', showSelection, { signal });

      this.syncAccordions();
      this.setupReveals();
      this.setupBackToTop(signal);
      this.classList.add('is-enhanced');
    }

    get accordionMode() {
      return this.dataset.mobileLayout === 'accordion' && !this._desktop.matches;
    }

    get motionEnabled() {
      return this.dataset.animations === 'true' && !this._motion.matches;
    }

    syncAccordions() {
      this._accordions.forEach((state) => {
        if (this.accordionMode) {
          this.restoreAttribute(state.summary, 'tabindex', state.originalTabindex);
          this.restoreAttribute(state.summary, 'aria-disabled', state.originalDisabled);
        } else {
          state.summary.setAttribute('tabindex', '-1');
          state.summary.setAttribute('aria-disabled', 'true');
        }
        this.setAccordion(state, this.accordionMode ? state.mobileOpen : true, false);
      });
    }

    setAccordion(state, open, animate) {
      const { details, summary, panel } = state;
      const startHeight = details.open ? panel.getBoundingClientRect().height : 0;
      this.cancelAnimation(state);
      state.targetOpen = open;
      if (!open && panel.contains(document.activeElement)) summary.focus({ preventScroll: true });

      if (!animate || !this.motionEnabled || typeof panel.animate !== 'function') {
        details.open = open;
        panel.removeAttribute('inert');
        return;
      }

      details.open = true;
      const endHeight = open ? panel.scrollHeight : 0;
      if (Math.abs(startHeight - endHeight) < 1) {
        details.open = open;
        panel.removeAttribute('inert');
        return;
      }
      // A closing panel must not retain keyboard focus or expose clipped links.
      panel.toggleAttribute('inert', !open);
      panel.style.overflow = 'hidden';
      const animation = panel.animate([
        { height: `${startHeight}px` },
        { height: `${endHeight}px` },
      ], { duration: 260, easing: 'cubic-bezier(0.22, 1, 0.36, 1)', fill: 'both' });
      state.animation = animation;
      animation.onfinish = () => {
        if (state.animation !== animation) return;
        details.open = state.targetOpen;
        this.cancelAnimation(state);
        panel.removeAttribute('inert');
      };
    }

    cancelAnimation(state) {
      if (state.animation) {
        state.animation.onfinish = null;
        state.animation.cancel();
        state.animation = null;
      }
      state.panel.style.removeProperty('overflow');
      state.panel.removeAttribute('inert');
    }

    setupReveals() {
      this._revealObserver?.disconnect();
      if (!this.motionEnabled || !('IntersectionObserver' in window)) {
        this.revealAll();
        return;
      }
      this._revealObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.reveal(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -20px 0px' });
      this.querySelectorAll('[data-reveal]').forEach((element) => {
        if (element.classList.contains('is-revealed') || element.contains(document.activeElement)) {
          this.reveal(element);
          return;
        }
        element.classList.add('is-reveal-pending');
        this._revealObserver.observe(element);
      });
    }

    reveal(element) {
      element.classList.remove('is-reveal-pending');
      element.classList.add('is-revealed');
      this._revealObserver?.unobserve(element);
    }

    revealAll() {
      this.querySelectorAll('[data-reveal]').forEach((element) => this.reveal(element));
      this._revealObserver?.disconnect();
    }

    setupBackToTop(signal) {
      this._topButton = this.querySelector('.flexora-footer__back-to-top');
      if (!this._topButton) return;
      this._buttonTabindex = this._topButton.getAttribute('tabindex');
      const threshold = Number(this.dataset.scrollThreshold);
      this._scrollThreshold = Number.isFinite(threshold) && threshold >= 0 ? threshold : 500;
      this._topButton.addEventListener('click', () => {
        // Moving focus first prevents it from being left on a disappearing control.
        this.focusPageTop();
        window.scrollTo({ top: 0, left: 0, behavior: this.motionEnabled ? 'smooth' : 'instant' });
      }, { signal });
      window.addEventListener('scroll', () => {
        if (this._scrollFrame) return;
        this._scrollFrame = requestAnimationFrame(() => {
          this._scrollFrame = null;
          this.updateBackToTop();
        });
      }, { passive: true, signal });
      this.updateBackToTop();
    }

    updateBackToTop() {
      const button = this._topButton;
      const visible = window.scrollY > this._scrollThreshold;
      if (visible === this._buttonVisible) return;
      this._buttonVisible = visible;
      clearTimeout(this._hideTimer);
      cancelAnimationFrame(this._visibilityFrame);
      if (visible) {
        button.hidden = false;
        button.removeAttribute('inert');
        this.restoreAttribute(button, 'tabindex', this._buttonTabindex);
        this._visibilityFrame = requestAnimationFrame(() => button.classList.add('is-visible'));
      } else {
        if (button.contains(document.activeElement)) this.focusPageTop();
        button.classList.remove('is-visible');
        button.setAttribute('inert', '');
        button.setAttribute('tabindex', '-1');
        if (!this.motionEnabled || button.hidden) button.hidden = true;
        else this._hideTimer = setTimeout(() => { button.hidden = true; }, 220);
      }
    }

    focusPageTop() {
      this._focusRestore?.();
      const target = document.querySelector('header') || document.querySelector('main, [role="main"]') || document.body;
      const originalTabindex = target.getAttribute('tabindex');
      if (originalTabindex === null) target.setAttribute('tabindex', '-1');
      const restore = () => {
        this.restoreAttribute(target, 'tabindex', originalTabindex);
        target.removeEventListener('blur', restore);
        this._focusRestore = null;
      };
      this._focusRestore = restore;
      target.addEventListener('blur', restore, { once: true });
      target.focus({ preventScroll: true });
    }

    restoreAttribute(element, name, value) {
      if (value === null) element.removeAttribute(name);
      else element.setAttribute(name, value);
    }

    disconnectedCallback() {
      this._controller?.abort();
      this._controller = null;
      this._initialized = false;
      this._revealObserver?.disconnect();
      clearTimeout(this._hideTimer);
      cancelAnimationFrame(this._scrollFrame);
      cancelAnimationFrame(this._resizeFrame);
      cancelAnimationFrame(this._visibilityFrame);
      this._scrollFrame = this._resizeFrame = this._visibilityFrame = null;
      this._focusRestore?.();
      this._accordions?.forEach((state) => {
        this.cancelAnimation(state);
        state.details.open = true;
        this.restoreAttribute(state.summary, 'tabindex', state.originalTabindex);
        this.restoreAttribute(state.summary, 'aria-disabled', state.originalDisabled);
      });
      this.querySelectorAll('[data-reveal]').forEach((element) => {
        element.classList.remove('is-reveal-pending');
      });
      if (this._topButton) {
        this._topButton.hidden = true;
        this._topButton.classList.remove('is-visible');
        this._topButton.removeAttribute('inert');
        this.restoreAttribute(this._topButton, 'tabindex', this._buttonTabindex);
      }
      this._buttonVisible = undefined;
      this.classList.remove('is-enhanced');
    }
  }

  customElements.define('flexora-footer', FlexoraFooter);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
